import type { NextOperation, VoyageReportKind } from '@felix/domain';

/**
 * Aşamanın içindeki raporun tek seçeneği aşamanın devamıdır (ADR 0057 §5): Noon'da "Continue Sea
 * Passage — Next: Noon Report or EOSP", demirde "Stay at Anchor". Karar noktalarında genel ad ve
 * "neye götürür" metni (ortak geri bildirimi 2026-10-19).
 */
const CONTINUES: Partial<Record<VoyageReportKind, NextOperation>> = {
  cosp: 'sea_passage',
  noon: 'sea_passage',
  anchorage_start: 'anchorage',
  anchorage_daily: 'anchorage',
  drift_start: 'drifting',
  drift_daily: 'drifting',
  waiting_start: 'waiting_orders',
  strait_entry: 'strait_canal',
  canal_entry: 'strait_canal',
};

/** Seçeneğin adı ve açıklamasının çeviri anahtarları (`voyage.sections.` altında). */
export function nextOperationKeys(
  kind: VoyageReportKind,
  option: string,
): { label: string; leadsTo: string } {
  return CONTINUES[kind] === option
    ? { label: `next.continue.${option}.label`, leadsTo: `next.continue.${option}.leadsTo` }
    : { label: `next.operations.${option}`, leadsTo: `next.leadsTo.${option}` };
}
